import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { sessionVerify } from '../../shared/api/sessionVerify';

const ProtectedRoute = ({ children }) => {
    const [loading, setLoading] = React.useState(true);
    const [isAuthorized, setIsAuthorized] = React.useState(false);

    React.useEffect(() => {
        const checkSession = async () => {
            try {
                const isValid = await sessionVerify();
                setIsAuthorized(isValid);
            } catch (error) {
                console.error('Error verifying session:', error);
            } finally {
                setLoading(false);
            }
        };
        checkSession();
    }, []);

    if (loading) {
        return <div>Loading...</div>; // Replace with your loading spinner or UI
    }

    return isAuthorized ? children : <Navigate to="/login" />;
};
export default ProtectedRoute;
